export const ProductListings = 'Product Listings'
export const SectionPreview = 'Section Preview'
export const ProjectNotes = 'Project Notes'
